import { Settings as SettingsIcon, Info } from 'lucide-react';
import DeviceTester from '../components/DeviceTester';

export default function Settings() {
  return (
    <div className="relative pt-24 pb-16 min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-pink-500 via-purple-600 to-blue-500 flex items-center justify-center">
            <SettingsIcon size={22} className="text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-black tracking-tight">Paramètres</h1>
            <p className="text-sm text-zinc-400">Caméra, micro et son — teste tout avant de lancer une battle.</p>
          </div>
        </div>

        <div className="glass-light rounded-2xl p-3 my-5 text-xs text-zinc-300 flex items-start gap-2 border border-blue-500/20">
          <Info size={14} className="mt-0.5 flex-shrink-0 text-blue-400" />
          <span>
            Sur mobile, autorise l&apos;accès caméra/micro dans le pop-up du navigateur. Sur Safari iOS, va dans
            <span className="font-semibold"> Réglages → Safari → Caméra/Micro</span> si tu as bloqué par erreur.
          </span>
        </div>

        <div className="glass rounded-3xl p-5 md:p-7">
          <DeviceTester />
        </div>
      </div>
    </div>
  );
}
